export default (params) => ({
  trigger: {
    name: 'web.vitals',
    params: params,
  },
  config: {
    schema: {
      metric_name: {
        type: 'string',
      },
      metric_value: {
        type: 'number',
      },
    },
    event: {
      name: 'vitals',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
